/**
 * Проверяет, является ли строка пустой или null.
 *
 * @param {string | null | undefined} str - Строка для проверки.
 * @returns {boolean} - true, если строка пустая или null, иначе false.
 */
export const strIsEmpty = (str: string | null | undefined): str is null | undefined => {
    if (typeof str !== "string" || str == null || str === "") {
        return true;
    }

    return false;
};

/**
 * Проверет, является ли строка пустой или эквивалетной `null`, если да, то заменит её на {@link replace}
 * @param str - потенциальная строка
 * @param replace - заменитель
 * @returns строка, если он не пустая, или заменитель
 */
export const strIsEmptyReplace = (str: string | null | undefined, replace: string): string => {
    return strIsEmpty(str) ? replace : (str as string);
};
